import * as React from "react";
import { useNavigate } from "react-router";

import { useQuery } from "@apollo/client";

import USGetAccount from "../../../graphql/query/USGetAccount.query";
import { UserDataComponentProps } from "../../../types/interfaces";
import PageLoading from "../../PageLoading";

const notAuthenticatedOnly = (
  Component: React.ComponentType<UserDataComponentProps>
) => {
  const NotAuthenticatedOnlyComponent = () => {
    const navigate = useNavigate();
    const { error, data } = useQuery(USGetAccount, {
      fetchPolicy: "network-only",
      errorPolicy: "all",
    });

    React.useEffect(() => {
      if (!error && data) navigate("/portal", { replace: true });
    }, [error, data, navigate]);

    if (error && data) {
      return <Component data={data} />;
    }
    return <PageLoading />;
  };

  return <NotAuthenticatedOnlyComponent />;
};

export default notAuthenticatedOnly;
